import { fetchPooledAverageAPY } from '@/lib/indexer'
import { useQuery } from '@tanstack/react-query'

const POOLED_AVERAGE_APY_STALE_TIME = 30 * 60 * 1000
const POOLED_AVERAGE_APY_GC_TIME = 2 * 60 * 60 * 1000

interface PooledAverageApyAsset {
  tokenAddress: string
  borrowAPY: number
  lendAPY: number
  updateCount: number
}

interface PooledAverageApyResponse {
  chainId: number
  days: number
  assets: PooledAverageApyAsset[]
  timestamp: number
}

function normalizePooledAverageApy(data: PooledAverageApyResponse): Map<string, number> {
  const map = new Map<string, number>()

  for (const asset of data.assets ?? []) {
    map.set(asset.tokenAddress.toLowerCase(), asset.lendAPY)
  }

  return map
}

export function usePooledAverageApy(chainId: number) {
  return useQuery({
    queryKey: ['pooled-average-apy', chainId],
    queryFn: () => fetchPooledAverageAPY(chainId) as Promise<PooledAverageApyResponse>,
    enabled: !!chainId,
    select: normalizePooledAverageApy,
    staleTime: POOLED_AVERAGE_APY_STALE_TIME,
    gcTime: POOLED_AVERAGE_APY_GC_TIME,
    refetchOnWindowFocus: false,
  })
}
